import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { IssuedRow } from "./types";

export default function useIssued(unit?: string) {
    const [issued, setIssued] = useState<IssuedRow[]>([]);

    const getIssued = async (forUnit: string | undefined = unit) => {
        const res = await apiClient.get(`/inventory/issued`, { params: { unit: forUnit } });
        setIssued(res.data);
    };

    useEffect(() => {
        getIssued(unit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unit]);

    const revoke = async (itemId: string, entityId: string, quantity: number, fromUnit: string) => {
        const res = await apiClient.post(`/inventory/revoke`, { itemId, entityType: "employee", entityId, quantity, fromUnit });
        return res.data as { returned: number };
    };

    return { issued, getIssued, revoke };
}
